import React from 'react';

import Input from '1-core/FormElements/Input';
import Button from '3-components/Buttons/Button';
import InputAutocomplete from '3-components/InputAutocomplete/InputAutocomplete';

interface ThinHeaderComponentProps {
    title?: string,
    showSearchbar?: boolean,
    searchBarValue?: string,
    // eslint-disable-next-line no-unused-vars
    searchBarUpdateHandle?: (value: string) => void,
    // searchBarLabel?: string,
    // sesrchButtonLabel?: string
    searchBarAutocompleteItems?: Record<string, unknown>[],
    // eslint-disable-next-line no-unused-vars
    updateSearchLocation?: (value: Record<string, unknown>) => void,
    inputAutocompleteActionButtonText?: string,
    inputAutocompleteActionButtonHandle?: () => void
}

const ThinHeaderComponent = (props: ThinHeaderComponentProps) => {
    const {
        title,
        showSearchbar,
        searchBarValue,
        searchBarUpdateHandle,
        searchBarAutocompleteItems,
        updateSearchLocation,
        inputAutocompleteActionButtonText,
        inputAutocompleteActionButtonHandle
    } = props;

    const inputUpdateHandle = (event: InputEvent) => {
        if (searchBarUpdateHandle) {
            searchBarUpdateHandle((event.target as HTMLInputElement).value);
        }
    };

    return (
        <section className="thin-header thin-header-search use-theme">
            <div className="thin-header-shape" />
            <div className="container">
                <div className="thin-header-copy">
                    <h1 className="thin-header-title">
                        {title}
                    </h1>
                    {showSearchbar && (
                        <>
                            <div className="thin-header-separator" />
                            <div className="thin-header-search-container">
                                {(!searchBarAutocompleteItems || searchBarAutocompleteItems.length < 1) && (
                                    <>
                                        <Input
                                            inputId="location-search-input"
                                            inputLabel="Enter your postcode or suburb"
                                            prefixIcon="search"
                                            inputValue={searchBarValue}
                                            inputOnChange={inputUpdateHandle}
                                        />
                                        <Button
                                            btnText="Clear"
                                            btnCustomClass={`thin-header-search-button ${searchBarValue ? 'visible' : 'invisible'}`}
                                            onclick={() => {
                                                if (searchBarUpdateHandle) {
                                                    searchBarUpdateHandle('');
                                                }
                                            }}
                                        />
                                    </>
                                )}
                                {searchBarAutocompleteItems && searchBarAutocompleteItems.length > 0 && (
                                    <InputAutocomplete
                                        inputId="location-search-input"
                                        inputLabel="Enter your postcode or suburb"
                                        prefixIcon="search"
                                        inputValue={searchBarValue}
                                        inputOnChange={inputUpdateHandle}
                                        autocompleteItems={searchBarAutocompleteItems}
                                        updateSearchLocation={updateSearchLocation}
                                        inputAutocompleteActionButtonText={inputAutocompleteActionButtonText}
                                        inputAutocompleteActionButtonHandle={inputAutocompleteActionButtonHandle}
                                    />
                                )}
                            </div>
                        </>
                    )}
                </div>
            </div>
        </section>
    );
};

export default ThinHeaderComponent;
